// Static lookup constants for the Sales Funnel / Leads CRM module.
// Sources mirror the mockup at va-admin-panel-v2(6).html.

export const PRIORITIES = [
  { value: "high", label: "High",   color: "#B02A2A", bg: "#FEE2E2" },
  { value: "med",  label: "Medium", color: "#C25A00", bg: "#FDF0E5" },
  { value: "low",  label: "Low",    color: "#1A7A4A", bg: "#E6F4EC" },
];

export const LEAD_SOURCES = [
  "Partner Referral",
  "Direct",
  "Outbound",
  "Inbound Inquiry",
  "Trade Show",
  "Cold Outreach",
  "LinkedIn Outreach",
  "Webinar",
  "Other",
];

export const TABS = [
  { key: "all", label: "All Leads" },
];

// Fallback stage colors if /list_stages has not yet loaded (keeps first paint
// matching the mockup palette).
export const FALLBACK_STAGES = [
  { stage_key: "new",         label: "New Lead",      color_hex: "#1C5BDE", bg_hex: "#E8EEFB", sort_order: 10, is_won: 0, is_lost: 0, is_system: 0, active: 1 },
  { stage_key: "contact",     label: "Contacted",     color_hex: "#6B3FA0", bg_hex: "#F0EAFA", sort_order: 20, is_won: 0, is_lost: 0, is_system: 0, active: 1 },
  { stage_key: "qualify",     label: "Qualifying",    color_hex: "#0369A1", bg_hex: "#E0F2FE", sort_order: 30, is_won: 0, is_lost: 0, is_system: 0, active: 1 },
  { stage_key: "demo",        label: "Demo / Trial",  color_hex: "#C25A00", bg_hex: "#FDF0E5", sort_order: 40, is_won: 0, is_lost: 0, is_system: 0, active: 1 },
  { stage_key: "proposal",    label: "Proposal Sent", color_hex: "#D97706", bg_hex: "#FEF3C7", sort_order: 50, is_won: 0, is_lost: 0, is_system: 0, active: 1 },
  { stage_key: "negotiation", label: "Negotiating",   color_hex: "#9E4500", bg_hex: "#FEE8D6", sort_order: 60, is_won: 0, is_lost: 0, is_system: 0, active: 1 },
  { stage_key: "won",         label: "Won",           color_hex: "#1A7A4A", bg_hex: "#E6F4EC", sort_order: 70, is_won: 1, is_lost: 0, is_system: 1, active: 1 },
  { stage_key: "lost",        label: "Lost",          color_hex: "#B02A2A", bg_hex: "#FEE2E2", sort_order: 80, is_won: 0, is_lost: 1, is_system: 1, active: 1 },
];

export const DEFAULT_PAGE_SIZE = 25;
